import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'

// Layout Components
import Navbar from './components/layout/Navbar'
import Sidebar from './components/layout/Sidebar'

// Page Components
import HomePage from './pages/HomePage'
import StoriesPage from './pages/StoriesPage'
import DatingPage from './pages/DatingPage'
import ShopPage from './pages/ShopPage'
import ChatPage from './pages/ChatPage'
import ProfilePage from './pages/ProfilePage'
import AuthPage from './pages/AuthPage'
import PremiumPage from './pages/PremiumPage'
import AchievementsPage from './pages/AchievementsPage'
import SettingsPage from './pages/SettingsPage'
import LivePage from './pages/LivePage'
import NotificationsPage from './pages/NotificationsPage'
import StoryDetailPage from './pages/StoryDetailPage'

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (replaces cacheTime)
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-dark-50 text-white">
          {/* Background Pattern */}
          <div className="fixed inset-0 bg-dots opacity-20 pointer-events-none" />
          
          {/* Main Navigation */}
          <Navbar />
          
          <div className="flex">
            {/* Sidebar Navigation */}
            <Sidebar />
            
            {/* Main Content Area */}
            <main className="flex-1 min-h-screen pt-16 lg:pl-64">
              <div className="container mx-auto px-4 py-8">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/stories" element={<StoriesPage />} />
                  <Route path="/stories/:id" element={<StoryDetailPage />} />
                  <Route path="/dating" element={<DatingPage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  <Route path="/chat" element={<ChatPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/auth" element={<AuthPage />} />
                  <Route path="/premium" element={<PremiumPage />} />
                  <Route path="/achievements" element={<AchievementsPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/live" element={<LivePage />} />
                  <Route path="/notifications" element={<NotificationsPage />} />
                </Routes>
              </div>
            </main>
          </div>
          
          {/* Toast Notifications */}
          <Toaster 
            theme="dark"
            position="top-right"
            toastOptions={{
              className: 'toast-glass',
              duration: 4000,
            }}
          />
        </div>
      </Router>
    </QueryClientProvider>
  )
}

export default App
